export const SM_RENOWNED_LOGO_PATH = 'logos/renowned-logomark-primary.svg';
export const LG_RENOWNED_LOGO_PATH = 'logos/renowned-logo-primary.svg';
